import { Component, OnInit, Input, OnChanges } from '@angular/core';

@Component({
	standalone: false,
	selector:    '[chart-axis]',
	templateUrl: './chart-axis.component.html'

})
export class ChartAxisComponent implements OnInit, OnChanges {
	@Input('config') config;

	constructor() {
	}

	ngOnInit() {

	}

	ngOnChanges(changes: any) {
		if (changes.hasOwnProperty('config')) {
			this.init();
		}
	}

	init() {

	}

}
